










































import { Vue, Component } from 'vue-property-decorator'
@Component({
  name: 'FilesUpdownAndroid'
})
export default class extends Vue {}
